<template>
  <div class="raman-scattering-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>Δν = ν_inc - ν_scat | 震动指纹光谱$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- The Molecule -->
          <g transform="translate(200, 120)">
             <!-- Bonds (Vibrating) -->
             <line :x1="-30-osc" y1="0" :x2="30+osc" y2="0" stroke="#888" stroke-width="4" />
             <!-- Atoms -->
             <circle :cx="-35-osc" cy="0" r="10" fill="#1e90ff" />
             <circle :cx="35+osc" cy="0" r="10" fill="#1e90ff" />
             <circle cx="0" cy="0" r="15" fill="#f5f6fa" />
          </g>

          <!-- Incident Photon (Green) -->
          <path d="M 0,60 Q 40,40 80,60 T 160,60" fill="none" stroke="#2ed573" stroke-width="2">
             <animate attributeName="opacity" values="1;0;1" dur="1s" repeatCount="indefinite" />
          </path>
          <text x="20" y="50" fill="#2ed573" font-size="8">入射光 (ν₀)</text>

          <!-- Scat Photon (Red/Stokes) -->
          <path v-if="scatType === 'stokes'" d="M 230,120 Q 270,140 310,120 T 400,120" fill="none" stroke="#ff4757" stroke-width="2">
             <animate attributeName="stroke-dasharray" values="0,100;100,0" dur="1s" repeatCount="indefinite" />
          </path>
          
          <!-- Scat Photon (Blue/Anti-Stokes) -->
          <path v-if="scatType === 'antistokes'" d="M 230,120 Q 260,110 290,120 T 400,120" fill="none" stroke="#1e90ff" stroke-width="2" />

          <!-- Energy Diagram -->
          <g transform="translate(40, 160)">
             <line x1="0" y1="40" x2="60" y2="40" stroke="#888" /> <!-- Ground state -->
             <line x1="0" y1="25" x2="60" y2="25" stroke="#888" stroke-dasharray="2,2" /> <!-- Vib level -->
             <text x="0" y="55" fill="#888" font-size="8">基态</text>
             <text x="0" y="20" fill="#888" font-size="8">震动能级</text>
          </g>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>散射类型: {{ typeLabel }}</label>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row items-center">
             <label>选择能级状态</label>
             <el-radio-group v-model="scatType" size="mini">
                <el-radio-button label="rayleigh">瑞利 (无损)</el-radio-button>
                <el-radio-button label="stokes">斯托克斯 (红移)</el-radio-button>
                <el-radio-button label="antistokes">反斯托克斯 (蓝移)</el-radio-button>
             </el-radio-group>
          </div>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>拉曼散射（Raman Scattering）是光子与分子发生非弹性碰撞的现象。当光照向分子时，极少数光子会交换能量，使得散射光的频率发生改变：损失能量给分子（斯托克斯散射）或从受激分子获得能量（反斯托克斯散射）。由于这种频率偏移（拉曼位移）与分子的特定震动/转动能级唯一对应，它被形象地称为分子的“光学指纹”。拉曼光谱仪广泛用于化学成分鉴定、考古文物分析以及制药工业的无损检测。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RamanScatteringViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      scatType: 'stokes',
      t: 0,
      timer: null
    }
  },
  computed: {
    typeLabel() {
       const map = { rayleigh: '瑞利散射 (波长不变)', stokes: '斯托克斯散射 (能量被分子吸收)', antistokes: '反斯托克斯 (分子放出能量)' };
       return map[this.scatType];
    },
    osc() {
       return Math.sin(this.t * 0.2) * 5;
    }
  },
  methods: {
    animate() {
       this.t += 1;
       this.timer = requestAnimationFrame(this.animate);
    }
  },
  mounted() { this.animate(); },
  beforeDestroy() { cancelAnimationFrame(this.timer); }
}
</script>

<style scoped lang="scss">
.raman-scattering-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.02); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(46, 213, 115, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
